import {Companies, Events, MatchContracts, Matches, Segments, Streaks, Tournaments} from "./models.js";

function Event(name) {
    // String
    const activeEffect = null;
    const monthlyEventName = null;
    const weeklyShowBeforeName = null;
    const weeklyShowAfterName = null;
    const brandName = null;
    const prestige = 'C';
    const objectName = 'event';

    // Integer
    const matchesCount = 0;
    const year = null;
    const month = null;
    const pointsEarned = null;
    const fansGained = null;
    const xp = 0;
    const hype = 0;
    const nextEventBoost = 0;
    const viewership = null;
    const totalFans = null;

    // Float
    const rating = null;

    // Numeric
    const weekNumber = null;

    // Boolean
    const weeklyShow = false;
    const temporaryEvent = null;

    // Objects
    const posterGraphic = {};

    // Foreign keys
    const companyId = null;
    const parentId = null;

    return {
        name,
        activeEffect,
        monthlyEventName,
        weeklyShowBeforeName,
        weeklyShowAfterName,
        brandName,
        prestige,
        matchesCount,
        year,
        month,
        pointsEarned,
        fansGained,
        xp,
        hype,
        nextEventBoost,
        viewership,
        totalFans,
        rating,
        weekNumber,
        weeklyShow,
        temporaryEvent,
        posterGraphic,
        companyId,
        parentId,
        objectName,
    };
}

function addEventMatches(event, matches) {
    matches.forEach(c => {
        c.eventId = event.$loki
    });
}

function removeEventMatches(event, matches) {
    matches.forEach(c => {
        c.eventId = null
    });
}

function getEventMatches(event) {
    return Matches.find({'eventId': event.$loki});
}

function getEventCompany(event) {
    return Companies.find({'$loki': event.companyId})[0];
}

function addChildEvent(event, childEvent) {
    childEvent.parentId = event.$loki;
}

function removeChildEvent(event, childEvent) {
    childEvent.parentId = null;
}

function getChildEvents(event) {
    return Events.find({'parentId': event.$loki});
}

function getParentEvent(event) {
    if (!event.parentId) {
        return
    }
    return Events.find({'$loki': event.parentId})[0];
}

function addEventMatchContracts(event, matchContracts) {
    matchContracts.forEach(c => {
        c.eventId = event.$loki
    });
}

function removeEventMatchContracts(event, matchContracts) {
    matchContracts.forEach(c => {
        c.eventId = null
    });
}

function getEventMatchContracts(event) {
    return MatchContracts.find({'eventId': event.$loki});
}

function addEventStreaks(event, streaks) {
    streaks.forEach(c => {
        c.eventId = event.$loki
    });
}

function removeEventStreaks(event, streaks) {
    streaks.forEach(c => {
        c.eventId = null
    });
}

function getEventStreaks(event) {
    return Streaks.find({'eventId': event.$loki});
}

function addEventTournaments(event, tournaments) {
    tournaments.forEach(c => {
        c.eventId = event.$loki
    });
}

function removeEventTournaments(event, tournaments) {
    tournaments.forEach(c => {
        c.eventId = null
    });
}

function getEventTournaments(event) {
    return Tournaments.find({'eventId': event.$loki});
}

function addEventSegments(event, segments) {
    segments.forEach(c => {
        c.eventId = event.$loki
    });
}

function removeEventSegments(event, segments) {
    segments.forEach(c => {
        c.eventId = null
    });
}

function getEventSegments(event) {
    return Segments.find({'eventId': event.$loki});
}

export { Event, addEventMatches, removeEventMatches, getEventMatches, getEventCompany, addChildEvent,
    removeChildEvent, getChildEvents, getParentEvent, addEventMatchContracts, removeEventMatchContracts,
    getEventMatchContracts, addEventStreaks, removeEventStreaks, getEventStreaks, addEventTournaments,
    removeEventTournaments, getEventTournaments, addEventSegments, removeEventSegments, getEventSegments };